import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

/**
 * WG Imports
 */
import { LoaderModule, LoaderService, WgExpanderModule, WgDropdownModule, WgNotificationsModule, WgNotificationsService } from '@watchguard/wg-ng-core';
import { WgSearchModule } from '@watchguard/wg-search';
import { SharedModule } from '../shared/shared.module';
import { CatalogsComponent } from './catalogs/catalogs.component';
import { SubCategoryListComponent } from './sub-category-list/sub-category-list.component';
import { ApiDetailsComponent } from './api-details/api-details.component';
import { PageNotFoundModule } from '../page-not-found/page-not-found.module';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';

const appRoutes: Routes = [
  {
      path: 'catalogs',
      component: CatalogsComponent
  },
  { path: 'catalogs/:id', component: SubCategoryListComponent },
  { path: 'catalogs/:id/:subcatid', component: SubCategoryListComponent },
  { path: 'catalogs/:id/:subcatid/:api/:version', component: ApiDetailsComponent },
  { path: '', redirectTo: 'catalogs', pathMatch: 'full' },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  declarations: [
    CatalogsComponent,
    SubCategoryListComponent,
    ApiDetailsComponent
  ],
  exports: [
    CatalogsComponent,
    ApiDetailsComponent,
    TranslateModule,
    RouterModule
  ],
  imports: [
    BrowserModule,
    PageNotFoundModule,
    SharedModule,
    WgSearchModule,
    LoaderModule,
    WgExpanderModule,
    WgDropdownModule,
    WgNotificationsModule,
    TranslateModule.forRoot(),
    RouterModule.forRoot(appRoutes, {})
  ],
  providers: [
    TranslateService,
    WgNotificationsService,
    LoaderService,
    provideHttpClient(withInterceptorsFromDi()),
    ...provideTranslateHttpLoader({
      prefix: 'locale-bundle/main/',
      suffix: '.json'
    })
  ]
})
export class ApiCatalogModule { }
